
import React, { FunctionComponent, FormEvent, useState, useEffect, createRef, } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Button,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';

import { RootState, AppDispatch, } from '../../store/store';
import { fetchUser, } from './sign-in';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import { useTranslation,  } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { push } from '@lagunovsky/redux-react-router'

import './SignIn.css';
import useTitle from '../../helpers/use-title';

import useValidator from '../../helpers/hooks/use-validator';

const SignIn: FunctionComponent = () =>  {

  const { t } = useTranslation( [ 'signIn' ] );

    const { t:tCommon } = useTranslation( [ 'common' ]);

  const loading = useSelector( ( state:RootState ) => state.pages.signIn.loading );
  const dispatch = useDispatch<AppDispatch>();

  useTitle( t( 'sign-in' ) );

  const usernameRef = createRef<HTMLInputElement>();
  const passwordRef = createRef<HTMLInputElement>();

  useValidator( [ usernameRef, ] )
    .required()
    .noEmpty()
    .isNumberOrEmail()

  useValidator( [ passwordRef, ] )
    .required()

  const onSubmit = ( event: FormEvent ) => {
    event.preventDefault();

    const target = event.target as HTMLFormElement;
    const data = Object.fromEntries(new FormData(target));
    dispatch( fetchUser( {
      username: ( data.username as string ).trim(),
      password: data.password as string,
    } ) );
  }

  const onClick = () => {
    dispatch( push( '/forgot-password' ) );
  }

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword( !showPassword );

  return (
    <div className="page page-sign-in">
      <AuthLayout language={ true } header={ true } >
          <form onSubmit={ onSubmit }>
            <h2>{ t( 'sign-in-at-hella-gutmann' ) }</h2>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoComplete="username email"
                  disabled={ loading !== 'idle' }
                  label={ t( 'your-login-V2' ) }
                  name="username"
                  inputRef={ usernameRef }
                  variant='standard'
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoComplete="password"
                  disabled={ loading !== 'idle' }
                  type={showPassword ? "text" : "password"}
                  label={ t( 'your-password' ) }
                  name="password"
                  inputRef={ passwordRef }
                  variant='standard'
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          title={ showPassword ? t( 'show-password' ) : t( 'hide-password' ) }
                          onClick={ handleClickShowPassword }
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 5 }}>
                  <LoadingButton
                    loading={ loading ==='pending' }
                    variant='contained'
                    type="submit"
                    fullWidth
                  >
                  { t( 'sign-in' ) }
                  </LoadingButton>
              </Grid>
              <Grid item xs={12}>
                <Button
                  onClick={ onClick }
                  fullWidth
                  variant='text'
                >{ t( 'forgot-your-password' ) }</Button>
              </Grid>
            </Grid>
          </form>
      </AuthLayout>
    </div>
  );
}

export default SignIn;
